import React from 'react';
import style from './style.scss';

const Recipes = ({product}) => {
    return (
        <div className='product-recipes'>
            <div className='product-recipes-title'>Receta</div>
            <div className='product-recipes-content' dangerouslySetInnerHTML={{ __html: product.Receta }}></div>
        </div>
    )
}

export default Recipes;